(() => {'use strict';
const selector='[data-retail-narrative]';
if(window.PoptexRetailNarrative){window.PoptexRetailNarrative.mount(document);return;}
function init(root){
 if(root.dataset.initialized==='true')return;
 root.dataset.initialized='true';
 const controller=new AbortController(),signal=controller.signal,observers=new Set(),timers=new Set(),frames=new Set();
 const texts=JSON.parse(root.querySelector('[data-retail-text]').textContent);
 const T=(key,values={})=>String(texts[key]??key).replace(/\{(\w+)\}/g,(_,name)=>String(values[name]??''));
 const on=(element,event,listener,options={})=>element?.addEventListener(event,listener,{...(typeof options==='boolean'?{capture:options}:options),signal});
 const trackObserver=observer=>(observers.add(observer),observer);
 const setTimeout=(fn,delay)=>{const timer=window.setTimeout(()=>{timers.delete(timer);if(!signal.aborted)fn();},delay);timers.add(timer);return timer;};
 const clearTimeout=timer=>{timers.delete(timer);window.clearTimeout(timer);};
 const requestAnimationFrame=fn=>{const frame=window.requestAnimationFrame(time=>{frames.delete(frame);if(!signal.aborted)fn(time);});frames.add(frame);return frame;};
 const cancelAnimationFrame=frame=>{frames.delete(frame);window.cancelAnimationFrame(frame);};


  const $ = (selector, scope = root) => scope.querySelector(selector);
  const $$ = (selector, scope = root) => Array.from(scope.querySelectorAll(selector));
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const scrollBehavior = () => reducedMotion.matches ? 'instant' : 'smooth';
  const setText = (selector, value) => { const node = $(selector); if (node) node.textContent = value; };
  const projectForm = $('#project-form');
  const sceneField = $('#project-scene');
  const coreFields = ['#project-company', '#project-email', '#project-client', '#project-name'];
  const imageRequests = new WeakMap();
  const setImage = (image, source, alt, reveal = false) => {
    if (!image || !source) return;
    const request = {};
    imageRequests.set(image, request);
    image.alt = alt || '';
    if (image.getAttribute('src') === source) { if (reveal) image.hidden = false; return; }
    const preview = new Image();
    preview.onload = () => {
      if (signal.aborted || imageRequests.get(image) !== request) return;
      image.src = source;
      if (reveal) image.hidden = false;
    };
    preview.src = source;
  };
  const focusProject = () => {
    projectForm?.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
    const next = coreFields.map(selector => $(selector)).find(field => field && (!field.value.trim() || !field.validity.valid)) || $('#project-company');
    next?.focus({ preventScroll: true });
  };

  let syncMobileCTA = () => {};
  const dialogTriggers = new WeakMap();
  const noFocusReturn = new WeakSet();
  const dialogs = $$('dialog');
  const syncDialogState = () => {
    document.body.classList.toggle('poptex-retail-narrative-dialog-open', dialogs.some(dialog => dialog.open));
    $$('[data-open-nav]').forEach(button => button.setAttribute('aria-expanded', String(Boolean($('#nav-dialog')?.open))));
    syncMobileCTA();
  };
  const closeDialog = (dialog, returnFocus = true) => {
    if (!dialog?.open) return;
    if (!returnFocus) noFocusReturn.add(dialog);
    dialog.close();
  };
  const openDialog = (dialog, trigger = document.activeElement) => {
    if (!dialog) return;
    dialogs.filter(other => other !== dialog && other.open).forEach(other => closeDialog(other, false));
    dialogTriggers.set(dialog, trigger);
    if (!dialog.open) dialog.showModal();
    syncDialogState();
  };
  dialogs.forEach(dialog => {
    on(dialog, 'close', () => {
      syncDialogState();
      if (noFocusReturn.has(dialog)) { noFocusReturn.delete(dialog); return; }
      const trigger = dialogTriggers.get(dialog);
      if (trigger?.isConnected && typeof trigger.focus === 'function') trigger.focus({ preventScroll: true });
    });
    on(dialog, 'click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeDialog(dialog);
    });
  });
  $$('[data-close-dialog], [data-close-nav]').forEach(button => on(button, 'click', () => closeDialog(button.closest('dialog'))));
  $$('[data-open-nav]').forEach(button => on(button, 'click', () => openDialog($('#nav-dialog'), button)));
  $$('#nav-dialog a').forEach(link => on(link, 'click', () => closeDialog($('#nav-dialog'), false)));

  // Commit captions only once native scrolling reaches a snap point.
  (() => {
    const root = $('#story-panorama');
    if (!root || !CSS.supports('scroll-snap-type', 'x mandatory')) return;
    const viewport = $('.panorama-viewport', root);
    const panels = $$('.panorama-caption', root);
    const buttons = $$('[data-panorama-stage]', root);
    const mobile = matchMedia('(max-width:720px)');
    let active = 0, target = null, timer, frame, touching = false, width = 0;
    const clamp = n => Math.max(0, Math.min(3, n));
    const commit = n => {
      const changed = active !== n;
      active = n; root.dataset.activeStage = String(n + 1);
      panels.forEach((panel, i) => {
        panel.classList.toggle('is-active', i === n);
        panel.setAttribute('aria-hidden', String(i !== n)); panel.inert = i !== n;
      });
      buttons.forEach((button, i) => i === n ? button.setAttribute('aria-current', 'step') : button.removeAttribute('aria-current'));
      $('.panorama-count', root).textContent = `0${n + 1} / 04`;
      if (changed) $('.panorama-status', root).textContent = T("step_number_of_4_title_06d9f7",{number:n+1,title:$('h3', panels[n]).textContent});
    };
    const settle = () => {
      if (touching || !mobile.matches) return;
      const w = viewport.getBoundingClientRect().width;
      if (!w) return;
      const n = clamp(Math.round(viewport.scrollLeft / w));
      if (Math.abs(viewport.scrollLeft - n * w) <= 2) { target = null; commit(n); }
    };
    const queueSettle = () => { clearTimeout(timer); timer = setTimeout(settle, 150); };
    const go = (n, animate = true) => {
      if (!mobile.matches) return;
      target = clamp(n);
      viewport.scrollTo({left: target * viewport.getBoundingClientRect().width, behavior: animate ? scrollBehavior() : 'instant'});
      if (!animate || reducedMotion.matches) { commit(target); target = null; }
      queueSettle();
    };
    const align = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const next = viewport.getBoundingClientRect().width;
        if (mobile.matches && next && Math.abs(next - width) > .5) go(target ?? active, false);
        width = next;
      });
    };
    on(viewport, 'scroll', queueSettle, {passive:true});
    on(viewport, 'scrollend', settle);
    on(viewport, 'touchstart', () => { touching = true; target = null; clearTimeout(timer); }, {passive:true});
    ['touchend','touchcancel'].forEach(event => on(viewport, event, () => { touching = false; queueSettle(); }, {passive:true}));
    on(viewport, 'wheel', () => { target = null; }, {passive:true});
    on(viewport, 'keydown', event => {
      const next = {ArrowLeft:(target ?? active)-1, ArrowRight:(target ?? active)+1, Home:0, End:3}[event.key];
      if (next === undefined) return;
      event.preventDefault(); go(next);
    });
    buttons.forEach((button, i) => on(button, 'click', () => go(i)));
    on(mobile, 'change', align);
    on(reducedMotion, 'change', () => { if (reducedMotion.matches && target !== null) go(target, false); });
    root.classList.add('is-ready'); $('#story').classList.add('has-panorama');
    if ('ResizeObserver' in window) trackObserver(new ResizeObserver(align)).observe(viewport);
    else on(window, 'resize', align);
    commit(0); align();
  })();

  let collections = [];
  try { collections = JSON.parse($('#collection-data')?.textContent || '[]'); } catch { collections = []; }
  if (!Array.isArray(collections)) collections = [];
  // Load the requested six-image set before replacing the visible panel.
  (() => {
    const tabs = $$('[data-audience-tab]');
    const panels = $$('[data-audience-panel]');
    const status = $('#audience-status');
    let active = 'gift', request = 0;
    const loaded = new Map();
    const preload = source => {
      if (!loaded.has(source)) loaded.set(source, new Promise((resolve, reject) => {
        const image = new Image();
        const fail = () => { clearTimeout(timeout); loaded.delete(source); reject(new Error(T("image_unavailable_7817cd"))); };
        const timeout = setTimeout(fail, 15000);
        image.onload = () => { clearTimeout(timeout); resolve(); };
        image.onerror = fail;
        image.src = source;
      }));
      return loaded.get(source);
    };
    const choose = async tab => {
      const group = tab.dataset.audienceTab;
      const ticket = ++request;
      if (group === active) { $('#audience-panels')?.removeAttribute('aria-busy'); if (status) status.textContent = ''; return; }
      const panel = panels.find(item => item.dataset.audiencePanel === group);
      if (!panel) return;
      $('#audience-panels')?.setAttribute('aria-busy', 'true');
      if (status) status.textContent = T("loading_audience_3fda1f",{audience:tab.textContent.trim()});
      try {
        const images = $$('img', panel);
        await Promise.all(images.map(image => preload(image.dataset.src || image.getAttribute('src'))));
        if (signal.aborted || ticket !== request) return;
        images.forEach(image => { if (image.dataset.src) { image.src = image.dataset.src; delete image.dataset.src; } });
        panels.forEach(item => { item.hidden = item !== panel; });
        tabs.forEach(item => { item.setAttribute('aria-selected', String(item === tab)); item.tabIndex = item === tab ? 0 : -1; });
        active = group;
        if (status) status.textContent = T("audience_six_collection_directions_3d952f",{audience:tab.textContent.trim()});
      } catch {
        if (signal.aborted || ticket !== request) return;
        if (status) status.textContent = T("images_could_not_load_please_try_this_tab_aga_0b0b46");
      } finally {
        if (!signal.aborted && ticket === request) $('#audience-panels')?.removeAttribute('aria-busy');
      }
    };
    tabs.forEach((tab, index) => {
      on(tab, 'click', () => choose(tab));
      on(tab, 'keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault(); tabs[next].focus(); choose(tabs[next]);
      });
    });
  })();

  on($('#image-dialog'), 'click', () => closeDialog($('#image-dialog')));

  // Collection photos open an image-only viewer; copy stays on the page.
  $$('[data-collection]').forEach(button => on(button, 'click', () => {
    const image = $('img', button);
    if (!image?.currentSrc) return;
    const enlarged = $('#zoom-image');
    enlarged.src = image.currentSrc;
    enlarged.alt = image.alt;
    openDialog($('#image-dialog'), button);
  }));
  const updateSelectedCollection = () => {
    const collection = collections.find(item => item.id === sceneField?.value);
    const image = $('#selected-collection-image');
    const clear = $('#clear-collection');
    if (clear) clear.hidden = !collection;
    if (!collection) {
      setText('#selected-collection-name', T("help_me_choose_252ae2"));
      if (image) { imageRequests.set(image, {}); image.hidden = true; image.removeAttribute('src'); image.alt = ''; }
      return;
    }
    setText('#selected-collection-name', collection.title);
    setImage(image, collection.image, collection.alt || collection.title, true);
  };
  on($('#clear-collection'), 'click', () => {
    if (sceneField) sceneField.value = '';
    updateSelectedCollection();
  });
  on(sceneField, 'change', updateSelectedCollection);
  updateSelectedCollection();

  const today = new Date();
  const minDate = [today.getFullYear(), String(today.getMonth() + 1).padStart(2, '0'), String(today.getDate()).padStart(2, '0')].join('-');
  if ($('#project-date')) $('#project-date').min = minDate;
  const numericFields = [$('#project-quantity'), $('#project-price')].filter(Boolean);
  const validateNumber = field => {
    field.setCustomValidity('');
    if (!field.value.trim()) return;
    const value = Number(field.value);
    if (!Number.isFinite(value)) field.setCustomValidity(T("enter_a_valid_number_1870d8"));
    else if (field.id === 'project-quantity' && !Number.isSafeInteger(value)) field.setCustomValidity(T("enter_a_whole_number_quantity_within_the_supp_331275"));
    else if (field.id === 'project-price' && Math.abs(value) > Number.MAX_SAFE_INTEGER / 100) field.setCustomValidity(T("enter_a_smaller_target_retail_price_e97506"));
  };
  numericFields.forEach(field => { on(field, 'input', () => validateNumber(field)); on(field, 'change', () => validateNumber(field)); });
  const fileInput = $('#project-files');
  const validFileTypes = new Set(['image/png', 'image/jpeg', 'image/webp', 'application/pdf']);
  const validateFiles = () => {
    if (!fileInput) return;
    const files = Array.from(fileInput.files || []);
    let error = '';
    if (files.length > 3) error = T("choose_up_to_3_reference_files_f898bc");
    else if (files.some(file => file.size > 10 * 1024 * 1024)) error = T("each_reference_file_must_be_10_mb_or_smaller_6c1f0a");
    else if (files.some(file => !validFileTypes.has(file.type))) error = T("use_jpg_png_webp_or_pdf_reference_files_8ded5f");
    fileInput.setCustomValidity(error);
    const list = $('#reference-files');
    if (list) list.replaceChildren(...(error ? [error] : files.map(file => `${file.name} (${new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumFractionDigits: 1 }).format(file.size / 1024 / 1024)} MB)`)).map(message => {
      const item = document.createElement('li');
      item.textContent = message;
      return item;
    }));
  };
  on(fileInput, 'change', validateFiles);
  const expandFieldDetails = field => {
    let details = field.closest('details');
    while (details) { details.open = true; details = details.parentElement?.closest('details'); }
  };
  const validateProject = () => {
    numericFields.forEach(validateNumber);
    validateFiles();
    const invalid = Array.from(projectForm.elements).filter(field => field.willValidate && !field.validity.valid);
    if (!invalid.length) return true;
    invalid.forEach(expandFieldDetails);
    invalid[0].scrollIntoView({ behavior: scrollBehavior(), block: 'center' });
    invalid[0].focus({ preventScroll: true });
    invalid[0].reportValidity();
    return false;
  };
  if (projectForm) projectForm.noValidate = true;
  on(projectForm, 'invalid', event => expandFieldDetails(event.target), true);
  const fieldText = name => {
    const field = projectForm?.elements.namedItem(name);
    if (!field) return '';
    if (field instanceof HTMLSelectElement) return field.value ? field.selectedOptions[0]?.textContent.trim() || field.value : '';
    return typeof field.value === 'string' ? field.value.trim() : '';
  };
  let briefText = '';
  on(projectForm, 'submit', event => {
    event.preventDefault();
    if (!validateProject()) return;
    const collection = collections.find(item => item.id === fieldText('scene'));
    const fields = [
      [T("business_name_a92175"), fieldText('company')], [T("contact_email_6d7fce"), fieldText('email')],
      [T("selling_environment_c7d951"), fieldText('client_type')], [T("destination_or_event_name_0312ec"), fieldText('project_name')],
      [T("collection_direction_2f0767"), collection?.title || T("help_me_choose_252ae2")],
      [T("estimated_quantity_275a7d"), fieldText('quantity') || T("to_discuss_49bf29")], [T("target_launch_e767ac"), fieldText('launch_date') || T("to_discuss_49bf29")]
    ];
    const price = fieldText('retail_price');
    if (price) fields.push([T("target_retail_price_0d98c6"), `${fieldText('currency') || 'USD'} ${price}`]);
    [[T("delivery_country_1c01e3"), 'country'], [T("postal_code_ae53ce"), 'postcode'], [T("exclusive_design_611297"), 'exclusivity'], [T("project_notes_6bffbd"), 'story'], [T("reference_links_notes_72b3c2"), 'references']].forEach(([label, name]) => {
      const value = fieldText(name);
      if (value) fields.push([label, value]);
    });
    const files = Array.from(fileInput?.files || []);
    if (files.length) fields.push([T("reference_files_not_uploaded_5bfb61"), files.map(file => file.name).join(', ')]);
    briefText = T("poptex_destination_event_retail_project_brief_571060",{fields:fields.map(([label,value])=>label+': '+value).join('\n\n')});
    const summary = $('#brief-summary');
    if (summary) summary.textContent = briefText;
    setText('#copy-status', T("your_brief_is_ready_nothing_has_been_sent_aaf3d6"));
    openDialog($('#brief-dialog'), event.submitter || $('#project-submit'));
  });
  on($('#copy-brief'), 'click', async () => {
    if (!briefText) return;
    try {
      if (!navigator.clipboard?.writeText) throw new Error(T("clipboard_unavailable_4ff69f"));
      await navigator.clipboard.writeText(briefText);
      setText('#copy-status', T("brief_copied_reference_files_remain_on_this_d_4e08d0"));
    } catch {
      const summary = $('#brief-summary');
      if (summary) {
        const range = document.createRange();
        range.selectNodeContents(summary);
        const selection = window.getSelection();
        selection?.removeAllRanges();
        selection?.addRange(range);
        summary.focus();
      }
      setText('#copy-status', T("select_the_brief_above_and_copy_it_manually_n_9f4a89"));
    }
  });

  const mobileCTA = $('#mobile-project-link');
  const mobileStart = $('[data-mobile-start]');
  const mobileReview = $('[data-mobile-review]');
  const submit = $('#project-submit');
  let formVisible = false;
  let submitVisible = false;
  syncMobileCTA = () => {
    if (!mobileCTA) return;
    mobileCTA.hidden = submitVisible || dialogs.some(dialog => dialog.open);
    if (mobileStart) mobileStart.hidden = formVisible;
    if (mobileReview) mobileReview.hidden = !formVisible;
  };
  if ('IntersectionObserver' in window && projectForm && submit) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === projectForm) formVisible = entry.isIntersecting;
        if (entry.target === submit) submitVisible = entry.isIntersecting;
      });
      syncMobileCTA();
    }, { threshold: 0, rootMargin: '-70px 0px -74px 0px' });
    trackObserver(observer);
    observer.observe(projectForm);
    observer.observe(submit);
  }
  syncMobileCTA();

const priority=$('#audience-priority');
const priorities={"gift":"local_recognition_price_fit_opening_stock_aaae3b","culture":"cultural_accuracy_artwork_rights_collection_d_9d0d8e","event":"on_sale_date_event_identity_merchandise_quant_f737c8"};
const updatePriority=()=>{const tab=$('[data-audience-tab][aria-selected=true]');if(!tab||!priority)return;const label=document.createElement('span');label.textContent=T('buying_focus_5459b5');priority.replaceChildren(label,document.createTextNode(T(priorities[tab.dataset.audienceTab])));};
if($('.audience-tabs'))trackObserver(new MutationObserver(updatePriority)).observe($('.audience-tabs'),{subtree:true,attributes:true,attributeFilter:['aria-selected']});
updatePriority();
const date=$('#project-date');on(date,'input',()=>date.dataset.empty=String(!date.value));

 root.retailCleanup=()=>{controller.abort();observers.forEach(observer=>observer.disconnect());timers.forEach(window.clearTimeout);frames.forEach(window.cancelAnimationFrame);root.querySelectorAll('dialog[open]').forEach(dialog=>dialog.close());document.body.classList.remove('poptex-retail-narrative-dialog-open');delete root.dataset.initialized;};
}
const mount=scope=>{if(scope.matches?.(selector))init(scope);scope.querySelectorAll(selector).forEach(init);};
const unmount=scope=>{if(scope.matches?.(selector))scope.retailCleanup?.();scope.querySelectorAll(selector).forEach(root=>root.retailCleanup?.());};
document.addEventListener('shopify:section:load',event=>mount(event.target));
document.addEventListener('shopify:section:unload',event=>unmount(event.target));
window.PoptexRetailNarrative={mount};mount(document);
})();
